import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import './index.scss'

import messages from '@/components/Card/messages'

const Loading = ({ isLoading, loadingMessage }: any) => {
  if (!isLoading) {
    return null
  }

  return (
    <div className="cardloader">
      <div className="cardloader__spinner" />
      <div className="cardloader__message">{loadingMessage}</div>
    </div>
  )
}

Loading.displayName = 'Loading'

Loading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  loadingMessage: PropTypes.node
}

Loading.defaultProps = {
  isLoading: true,
  loadingMessage: <FormattedMessage {...messages.loading} />
}

export default Loading
